import { createContext, useContext } from 'react';

/**
 * Portal target intended **only** for floating UI (Popover, Autocomplete, Select, etc.)
 * that needs to escape a parent's scroll-lock or pointer-events trap while staying
 * outside surfaces like Modal or Drawer.
 *
 * Deliberately separate from `ContainerElementContext`, which every portal consumer
 * (Modal, Drawer, Notifications, …) reads. Overriding the global container for a
 * subtree would force full-screen overlays to mount inside whatever local wrapper set
 * it (e.g. a BottomSheet's animated/transformed `Drawer.Content`), clipping or
 * mispositioning them.
 *
 * Consumers should prefer this context first and fall back to
 * `ContainerElementContext` when it returns `null` (no local override).
 */
const PopoverContainerContext = createContext<HTMLElement | null>(null);

const usePopoverContainerContext = () => useContext(PopoverContainerContext);

export { usePopoverContainerContext };
export default PopoverContainerContext;
